import { render, staticRenderFns } from "./addedit-defect.vue?vue&type=template&id=99d59ba4"
import script from "./addedit-defect.vue?vue&type=script&lang=js"
export * from "./addedit-defect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports